const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:$|T)/
const DISPLAY_DATE_PATTERN = /^(\d{2})\.(\d{2})\.(\d{4})$/

export function parseDateOnly(dateFns, value) {
  if (value instanceof Date) {
    return dateFns.isValid(value) ? new Date(value.getTime()) : null
  }

  if (typeof value !== 'string') {
    return null
  }

  const trimmedValue = value.trim()
  const dateOnlyMatch = trimmedValue.match(DATE_ONLY_PATTERN)

  if (dateOnlyMatch) {
    return createLocalDate(
      Number(dateOnlyMatch[1]),
      Number(dateOnlyMatch[2]),
      Number(dateOnlyMatch[3])
    )
  }

  const displayDateMatch = trimmedValue.match(DISPLAY_DATE_PATTERN)

  if (displayDateMatch) {
    return createLocalDate(
      Number(displayDateMatch[3]),
      Number(displayDateMatch[2]),
      Number(displayDateMatch[1])
    )
  }

  return null
}

export function formatDateOnly(dateFns, value) {
  const date = parseDateOnly(dateFns, value)

  return date ? dateFns.format(date, 'yyyy-MM-dd') : null
}

export function formatDates(dateFns, data, dateFields) {
  if (!dateFields) {
    console.error('No date fields provided')
    return data
  }

  dateFields.forEach((field) => {
    const value = data[field]

    if (value === true) {
      data[field] = formatDateOnly(dateFns, new Date())
    } else if (value === false || value === null) {
      data[field] = null
    } else {
      data[field] = formatDateOnly(dateFns, value)
    }
  })

  return data
}

function createLocalDate(year, month, day) {
  const date = new Date(year, month - 1, day)

  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null
  }

  return date
}

export function replaceUndefinedWithNull(data) {
  Object.keys(data).forEach((key) => {
    if (data[key] === undefined) {
      data[key] = null
    }
  })

  return data
}
